export const visit = (vm, at) => {
at({ "nl": { "ui-addon-video-player": { "havingTroubleWithVideoLink": "Problemen bij het bekijken van de video?", "playButton": "Afspelen" } } });
};